import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { SPSAOperationViewModel } from './spsa-operation-view-model';


export class SPSAOperationViewResponse extends GlobalResponseObject{
    [x: string]: any;
    data: SPSAOperationViewModel;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data: SPSAOperationViewModel) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 